<div class="relative">
  <!-- <ngx-ui-loader loaderId="video-loader"></ngx-ui-loader> -->
  <div class="close-btn-container">
    <button vng-icon-button small color="none" type="button" class="close-icon" aria-label="Close" (click)="close()">
      <vng-icon name="close" [outline]="false"></vng-icon>
    </button>
  </div>
  <iframe
    (load)="myLoadEvent()"
    [src]="safeURL"
    width="100%"
    height="430px"
    frameborder="0"
    allowfullscreen
  ></iframe>
</div>
